import { isValid, parse } from 'date-fns';
// Matches a complete date attempt: 1-2 digit day, 1-2 digit month, exactly 4-digit year.
// Returns undefined (still typing) for anything that doesn't yet match.
const COMPLETE_INPUT_PATTERN_REGEX = /^\d{1,2}\.\d{1,2}\.\d{4}$/;
const PARSE_DATE_FORMAT = 'd.M.yyyy';
export const parseInputToDate = (text) => {
    const isEmptyString = text.trim() === '';
    const isCompleteAttempt = COMPLETE_INPUT_PATTERN_REGEX.test(text);
    if (isEmptyString || !isCompleteAttempt)
        return undefined;
    const parsedDate = parse(text, PARSE_DATE_FORMAT, new Date());
    const isValidDate = isValid(parsedDate);
    const resultDate = isValidDate ? parsedDate : new Date(NaN);
    return resultDate;
};
